<template>
    <div style="width: 100%" >


        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <b-input  icon="magnify" v-model="searchData"></b-input>
                </div>
                <div class="level-item">
                    <b-button type="is-danger"
                              size="is-small"
                              icon-right="filter"
                              v-if="searchData.length>0"
                              @click="searchData='' " />
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                </div>
            </div>
        </nav>
    <b-table
            :data="isEmpty ? [] : dataTableFilter"
            bordered
            striped
            narrowed
            hoverable
            focusable
            :selected.sync="dataSelected"
            paginated
            :per-page="perPage"
            :current-page.sync="currentPage"

            mobile-cards
              >


        <b-table-column   label="Name" v-slot="props">
            {{ props.row.name }}
        </b-table-column>
        <b-table-column   label="Code" v-slot="props">
            {{ props.row.code }}
        </b-table-column>
        <b-table-column   label="status" v-slot="props">
            <span>
                <b-icon
                        :type="props.row.status ? 'is-success' : 'is-danger'"
                        :icon="props.row.status  ? `check` : `close` ">
                </b-icon>
            </span>
        </b-table-column>


<!--          <b-table-column   label="#" v-slot="props">-->
<!--            <b-button type="is-warning" icon-right="pencil" @click="editItemDx(props.row.id)" />-->


<!--        </b-table-column>-->


        <template slot="empty">
            <EmptyTable />
        </template>


    </b-table>
    </div>
</template>

<script>
    import EmptyTable from "../EmptyTable";
    export default {
        name: "DxTableData",
        components:{
            EmptyTable
        },
        props:{
            dataTable : Array,
            level : Number
        },
        computed:{
            dataTableFilter:function () {
               return this.dataTable.filter(dat=>{
                  return   dat.name.toUpperCase().indexOf(this.searchData.toUpperCase()) > -1
               })
            }
        },
        methods:{
            clearDataSelected(){
                this.dataSelected = null
            }
            // editItemDx(_id){
            //     console.log(_id)
            //     this.$emit('editIDDxCode',_id)
            // }
        },
        data(){
            return{
                dataSelected : null,
                isEmpty : false,
                searchData : "",

                perPage : 10,
                currentPage : 1
            }
        },
        watch:{
            dataSelected: function (val) {
                if(val){
                    this.$emit('dataSelected',{"level" : this.level , "data_selected" :this.dataSelected})
                }
            }
        }
    }
</script>

<style scoped>

</style>